import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Button, Tooltip, Badge, Input, Table, Card, CardHeader, CardBody } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import moment from "moment";
import { Link } from 'react-router-dom'
import SKModal from "./SKModal";
import SKCollectiveModal from "./SKCollectiveModal"

class TablePreocessedComponent extends Component {
	dataTableBloc = new DataTableBloc();
	indexBloc = new IndexBloc();

	historyTable = "tabelunprocess";
	defaultOrder = "punishment_discipline_id";
	defaultSize = 10;
	defaultSort = "asc";
	configDatatable = {
		...config("datatable"),
		sort: {
			column: this.defaultOrder,
			order: this.defaultSort,
		},
	};
	modal_confirm_status = 0
	modal_confirm_message = ""
	modal_confirm_sucess_message = "data berhasil diproses"
	modal_confirm_error_message = "data gagal diproses"

	constructor(props) {
		super(props);
		this.state = {
			tooltip: false,
			berkasUuid: null,
			detailUuid: null,
			inputSKUuid: null,
			updateUuid: null,
			inactiveUuid: null,
			uploadSkUuid: null,
			uploadHasilUuid	: null,
			inactiveSKUuid: null,
			defaultSize: 10,
			rows: [],
			totalRow: 0,
			loadingTable: true,
			filter: sessionStorage.getItem(this.historyTable)
				? JSON.parse(sessionStorage.getItem(this.historyTable))
				: {
					filter_value: "",
					page_number: 1,
					page_size: this.defaultSize,
					sort_order: {
						column: this.defaultOrder,
						order: this.defaultSort,
					},
				},
			dataSelected: [],
			checkAll: false,
			modal: false,
			modalSKC: false,
		};
	}
	toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

	loadData = async () => {
		/* history Datatable */
		sessionStorage.setItem(
			this.historyTable,
			JSON.stringify(this.state.filter)
		);

		/* kirim ke server */
		let offset =
			(this.state.filter.page_number - 1) * this.state.filter.page_size;
		if (this.state.defaultSize !== this.state.filter.page_size) {
			this.setState({
				defaultSize: this.state.filter.page_size,
			});
			offset = 0;
			this.configDatatable.page_number = 1;
		}
		const query = {
			uuid: this.props.uuid,
			employeeuuid: this.props.employeeuuid,
			isadmin: this.props.isadmin,
			search: this.state.filter.filter_value,
			limit: this.state.filter.page_size,
			offset: offset,
			order: this.state.filter.sort_order.column,
			sort: this.state.filter.sort_order.order,
			status: 1,
			is_process: 1
		};
		await this.dataTableBloc.fetchRowTableunprocess(query, this.source.token);
	};

	toggle = () => {
		this.setState({ modal: !this.state.modal })
	}

	toggleModalSKC = () => {
		this.setState({ modalSKC: !this.state.modalSKC })
	}

	dateParse = (input) => {
		let res = "-";
		if (input != "" && input != null) {
			res = moment(input).format('DD/MM/YYYY')
		}
		return res;
	}

	handleChecked = (e, uuid) => {
		var checked = e.target.checked;
		if (checked) {
			this.setState({
				dataSelected: [
					...this.state.dataSelected,
					uuid
				]
			})
		} else {
			var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
			this.setState({
				dataSelected: filteredAry
			})
		}
		//console.log(uuid, checked);    
	}

	handleCheckAll = (e) => {
		let checked = e.target.checked;
		let uuidSelected = [];
		let idx = 0;
		for (let i = 0; i < this.state.rows.length; i++) {
			let thisId = this.state.rows[i].promotion_id
			let thisUuid = this.state.rows[i].promotion_uuid

			if (this.state.rows[i].promotion_collective_decree_uuid == null) {
				this.setState({
					[`check${thisId}`]: !this.state.checkAll,
				})
				if (checked == true) {
					uuidSelected[idx] = thisUuid;
				}
				idx++;
			}
		}

		this.setState({
			checkAll: !this.state.checkAll,
			dataSelected: uuidSelected
		})
	}

	handleDownloadDraftSK = (uuid) => {
		this.indexBloc.fetchDownloadDraftSK({
			promotion_uuid: uuid
		});
	}

	handleButtonProcess = () => {
		console.log(this.state.dataSelected)
		this.modal_confirm_message = "Apakah anda yakin akan menambahkan pegawai terpilih?"
		this.modal_confirm_status = 1;
		this.setState({
			confirm: true
		})
	}

	handleButtonExportUsulan = () => {
		this.indexBloc.fetchExportUsulan({
			period_uuid: this.props.uuid,
		});
	}

	fetchListSKCollective = () => {
		this.indexBloc.fetchListSKC({ period_uuid: this.props.uuid });
	}

	setTokenAPI = () => {
		if (typeof this.source != typeof undefined) {
			this.source.cancel();
		}
		this.source = cancelToken();
		this.loadData();
	};

	inactiveData = async () => {
		console.log(this.state.inactiveUuid)
		this.setState({
			confirm: true
		})
		await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
	};
	inactiveSKData = async () => {
		this.setState({
			confirm: true
		})
		await this.dataTableBloc.fetchInactiveSK({ uuid: this.state.inactiveSKUuid });
	};

	confirmResponse = (response) => {
		console.log(response)

		let forState = {};
		switch (response) {
			case "cancel":
				forState = {
					confirm: false,
				};
				break;
			case 'confirm':
				this.modal_confirm_message = "Apakah anda yakin akan menghapus pegawai ini?"
				this.modal_confirm_status = 1;
				forState = {
					loading: true,
					confirm: false
				}
				if (this.state.inactiveSKUuid != null) {
					this.inactiveSKData()

				} else {
					this.inactiveData()
				}

				break;
			case "success":
				forState = {
					success: false,
					redirect: true,
				};
				break;
			case "failed":
				forState = {
					failed: false,
				};
				break;
			default:
		}

		this.setState(forState);
	};


	componentDidMount() {
		this.setTokenAPI();

		this.dataTableBloc.rowtableUnprocessChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.INITIAL:
					this.setState({
						loadingTable: false,
					});
					break;
				case apiResponse.LOADING:
					this.setState({
						loadingTable: true,
					});
					break;
				case apiResponse.COMPLETED:
					const response = result.data.response;

					// set state for every checkbox
					for (let i = 0; i < response.result.length; i++) {
						let thisId = response.result[i].promotion_id
						this.setState({
							[`check${thisId}`]: false
						})
					}
					this.setState({
						totalRow: response.total,
						rows: response.result,
						loadingTable: false,
					});
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});
		this.dataTableBloc.inactiveChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true
					}, function () {
						this.setTokenAPI()
						this.props.handleInactiveSuccess()
						this.fetchListSKCollective()

					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break
				default:
					break
			}
		})
		this.dataTableBloc.inactiveSKChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true
					}, function () {
						this.setTokenAPI()
						this.fetchListSKCollective()
						
						//this.props.handleInactiveSuccess()
					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break
				default:
					break
			}
		})
		this.indexBloc.downloadDraftSKChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})
		this.indexBloc.exportUsulanChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})

		this.indexBloc.listSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response
						this.setState({
							skc_list: response.result,
						})
					}
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})
		this.fetchListSKCollective()

		this.indexBloc.downloadSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})
	}

	componentWillUnmount() {
		this.dataTableBloc.rowtableUnprocessChannel.unsubscribe();
	}

	// columns = [
	// 	{
	// 	  key: "promotion_id",
	// 	  text: "Pilih",
	// 	  className: "promotion_id",
	// 	  sortable: false,
	// 	  header: () => {
	// 		return (
	// 		  <div className="form-check text-center font-size-16">
	// 			<Input
	// 			  className="form-check-input"
	// 			  type="checkbox"
	// 			  name="checkAll"
	// 			  value=""
	// 			  checked={this.state.checkAll}
	// 			  onChange={(event) => {
	// 				this.handleCheckAll(event)
	// 			  }}
	// 			/>
	// 		  </div>
	// 		)
	// 	  },
	// 	  cell: record => {
	// 		const thisId = record.promotion_id
	// 		return (
	// 		  <div className="form-check text-center font-size-16">
	// 			<Input
	// 			  type="checkbox"
	// 			  className="form-check-input"
	// 			  id={'checkbox' + thisId}
	// 			  onChange={
	// 				(event) => {
	// 				  this.handleChecked(event, record.promotion_uuid);
	// 				  this.setState({
	// 					[`check${thisId}`]: !this.state[`check${thisId}`]
	// 				  })
	// 				}
	// 			  }
	// 			  checked={this.state[`check${thisId}`]}
	// 			/>
	// 		  </div>
	// 		)
	// 	  }
	// 	},
	// 	{
	// 	  key: "employee_nip",
	// 	  text: "Pegawai",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		return (
	// 		  <div
	// 			dangerouslySetInnerHTML={{
	// 			  __html:
	// 				"<b>" +
	// 				record.employee_nip +
	// 				"</b><br>" +
	// 				record.employee_full_name 
	// 			}}
	// 		  />
	// 		);
	// 	  },
	// 	},
	// 	{
	// 	  key: "promotion_work_unit_name",
	// 	  text: "Unit Kerja",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		return (
	// 		  <div
	// 			dangerouslySetInnerHTML={{
	// 			  __html: ((record.promotion_work_unit_name!=null)?record.promotion_work_unit_name.replace(/»/g, '<br>'):''),
	// 			}}
	// 		  />
	// 		);
	// 	  },
	// 	},
	// 	{
	// 	  key: "promotion_rank_name_old",
	// 	  text: "Pangkat",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		return (
	// 		  <div
	// 			dangerouslySetInnerHTML={{
	// 			  __html: record.promotion_rank_name_old,
	// 			}}
	// 		  />
	// 		);
	// 	  },
	// 	},
	// 	{
	// 	  key: "promotion_rank_group_room_old",
	// 	  text: "Golongan",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		return (
	// 		  <div
	// 			dangerouslySetInnerHTML={{
	// 			  __html: record.promotion_rank_group_room_old,
	// 			}}
	// 		  />
	// 		);
	// 	  },
	// 	},
	// 	{
	// 	  key: "rank_group_room",
	// 	  text: "Masa Kerja",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell : record => {
	// 		return (
	// 		  <>
	// 			<b>{record.promotion_year_period}</b> Tahun
	// 			<div><b>{record.promotion_month_period}</b> Bulan</div>
	// 		  </>
	// 		)
	// 	  }
	// 	},
		
	
	// 	{
	// 	  key: "promotion_rank_tmt_old",
	// 	  text: "TMT Pangkat",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		let res = "-";
	// 		if (
	// 		  record.promotion_rank_tmt_old != null &&
	// 		  record.promotion_rank_tmt_old != ""
	// 		) {
	// 		  res = moment(record.promotion_rank_tmt_old).format("DD-MM-YYYY");
	// 		}
	// 		return res;
	// 	  },
	// 	},
	// 	{
	// 	  key: "rank_type_name",
	// 	  text: "Jenis Kenaikan Pangkat",
	// 	  className: "",
	// 	  sortable: true,
	// 	  cell: (record) => {
	// 		return (
	// 		  <div dangerouslySetInnerHTML={{ __html: record.rank_type_name }} />
	// 		);
	// 	  },
	// 	},
	// 	{
	// 	  key: "punishments",
	// 	  text: "Hukuman Disiplin",
	// 	  className: "punishments",
	// 	  sortable: true,
	// 	  cell: record => {
	// 		let punishments = record.punishments;
	// 		if ((typeof record.punishments !== "undefined")) {
	// 		  return (
	// 			punishments.map(item => <li key={item.punishment_id}> {item.punishment_long_name} </li>)
	// 		  )
	// 		}

	// 		return "-";
	// 	  }
	// 	},
	// 	{
	// 	  key: "promotion_status",
	// 	  text: "Status",
	// 	  sortable: false,
	// 	  cell: (record) => {
	// 		let status = parseInt(record.promotion_status);
	// 		if (status == -1) {
	// 		  status = (
	// 			<label className="badge rounded-pill bg-soft-info font-size-12">
	// 			  Rekomendasi
	// 			</label>
	// 		  );
	// 		} else if (status == 0) {
	// 		  status = (
	// 			<label className="badge rounded-pill bg-soft-success font-size-12">
	// 			  Menunggu Proses
	// 			</label>
	// 		  );
	// 		} else if (status == 1) {
	// 		  status = (
	// 			<label className="badge rounded-pill bg-soft-success font-size-12">
	// 			  Disetujui
	// 			</label>
	// 		  );
	// 		} else if (status == 2) {
	// 		  status = (
	// 			<label className="badge rounded-pill bg-soft-error font-size-12">
	// 			  Ditolak
	// 			</label>
	// 		  );
	// 		}
	// 		return <span> {status} </span>;
	// 	  },
	// 	},
	// 	{
	// 		key: "action",
	// 		text: "Action",
	// 		className: "action",
	// 		width: 120,
	// 		sortable: false,
	// 		align: "center",
	// 		cell: (record) => {
	// 			const thisId = record.promotion_id;
	// 			return (
	// 				<Fragment>
	// 					{record.promotion_is_rekomendation == 1 &&
	// 						record.promotion_status == -1 &&
	// 						accessRole("update") ? (
	// 						<span>
	// 							<button
	// 								className="btn btn-primary btn-sm"
	// 								id={"update-" + thisId}
	// 								onClick={() => {
	// 									this.setState({
	// 										updateUuid: record.employee_uuid,
	// 									});
	// 								}}
	// 								style={{
	// 									marginRight: "2px",
	// 									padding: "2px 5px",
	// 								}}
	// 							>
	// 								<i className="uil-list-ul"></i>
	// 							</button>
	// 							<Tooltip
	// 								style={{
	// 									marginBottom: 2,
	// 								}}
	// 								placement="top"
	// 								isOpen={this.state["update" + thisId]}
	// 								target={"update-" + thisId}
	// 								toggle={() => {
	// 									this.setState({
	// 										["update" + thisId]: !this.state["update" + thisId],
	// 									});
	// 								}}
	// 							>
	// 								Masukan ke daftar
	// 							</Tooltip>
	// 						</span>
	// 					) : null}

	// 					{record.promotion_status == 0 && accessRole("read") ? (
	// 						<span>
	// 							<button
	// 								className="btn btn-warning btn-sm"
	// 								id={"berkas-" + thisId}
	// 								onClick={() => {
	// 									this.setState({
	// 										berkasUuid: record.employee_uuid,
	// 									});
	// 								}}
	// 								style={{
	// 									marginRight: '2px',
	// 									padding: '2px 5px'
	// 								}}>
	// 								<i className="uil-file-plus-alt"></i>
	// 							</button>
	// 							<Tooltip
	// 								style={{
	// 									marginBottom: 2
	// 								}}
	// 								placement="top" isOpen={this.state["berkas" + thisId]} target={"berkas-" + thisId}
	// 								toggle={() => {
	// 									this.setState({
	// 										["berkas" + thisId]: !this.state["berkas" + thisId]
	// 									})
	// 								}}
	// 							>Berkas</Tooltip>
	// 						</span>
	// 					) : null}

	// 					{record.promotion_status == 0 && record.promotion_decree_number != null && accessRole("read") ? (
	// 						<span>
	// 							<button
	// 								className="btn btn-info btn-sm"
	// 								id={"draftSk-" + thisId}
	// 								onClick={() => {
	// 									this.handleDownloadDraftSK(record.promotion_uuid)
	// 								}}
	// 								style={{
	// 									marginRight: '2px',
	// 									padding: '2px 5px'
	// 								}}>
	// 								<i className="uil-file-download-alt"></i>
	// 							</button>
	// 							<Tooltip
	// 								style={{
	// 									marginBottom: 2
	// 								}}
	// 								placement="top" isOpen={this.state["draftSk" + thisId]} target={"draftSk-" + thisId}
	// 								toggle={() => {
	// 									this.setState({
	// 										["draftSk" + thisId]: !this.state["draftSk" + thisId]
	// 									})
	// 								}}
	// 							>Download Draft SK</Tooltip>
	// 						</span>
	// 					) : null}

	// 					{/* {record.promotion_status == 0 && record.promotion_decree_number == null && accessRole("create") ? (
	// 						<span>
	// 								<button
	// 										className="btn btn-danger btn-sm"
	// 										id={"inputSk-" + thisId}
	// 										onClick={() => {
	// 												this.setState({inputSKUuid: record.promotion_uuid})
	// 												this.toggle()
	// 										}}
	// 										style={{
	// 												marginRight: '2px',
	// 												padding: '2px 5px'
	// 										}}>
	// 												<i className="uil-pen"></i>
	// 								</button>
	// 								<Tooltip
	// 										style={{
	// 												marginBottom: 2
	// 										}}
	// 										placement="top" isOpen={this.state["inputSk" + thisId]} target={"inputSk-" + thisId}
	// 										toggle={() => {
	// 												this.setState({
	// 														["inputSk" + thisId] : !this.state["inputSk" + thisId]
	// 												})
	// 										}}
	// 								>Input SK</Tooltip>
	// 						</span>
	// 					) : null} */}

	// 					{record.promotion_status == 0 && record.promotion_decree_number != null && accessRole("update") ? (
	// 						<span>
	// 							<Link to={`?verifikasi&uuid=` + this.props.uuid + `&pegawai_uuid=` + record.employee_uuid}>
	// 								<button

	// 									className="btn btn-success btn-sm"
	// 									id={"verifikasi-" + thisId}

	// 									style={{
	// 										marginRight: "2px",
	// 										padding: "2px 5px",
	// 									}}
	// 								>
	// 									<i className="uil-check"></i>
	// 								</button>
	// 								<Tooltip
	// 									style={{
	// 										marginBottom: 2,
	// 									}}
	// 									placement="top"
	// 									isOpen={this.state["verifikasi" + thisId]}
	// 									target={"verifikasi-" + thisId}
	// 									toggle={() => {
	// 										this.setState({
	// 											["verifikasi" + thisId]:
	// 												!this.state["verifikasi" + thisId],
	// 										});
	// 									}}
	// 								>
	// 									Verifikasi
	// 								</Tooltip>
	// 							</Link>
	// 						</span>
	// 					) : null}

	// 					{record.promotion_status == 1 && accessRole("read") ? (
	// 						<span>
	// 							<Link to={`?detail&uuid=` + this.props.uuid + `&pegawai_uuid=` + record.employee_uuid}>
	// 								<button

	// 									className="btn btn-success btn-sm"
	// 									id={"detail-" + thisId}

	// 									style={{
	// 										marginRight: "2px",
	// 										padding: "2px 5px",
	// 									}}
	// 								>
	// 									<i className="uil-file-search-alt"></i>
	// 								</button>
	// 								<Tooltip
	// 									style={{
	// 										marginBottom: 2,
	// 									}}
	// 									placement="top"
	// 									isOpen={this.state["detail" + thisId]}
	// 									target={"detail-" + thisId}
	// 									toggle={() => {
	// 										this.setState({
	// 											["detail" + thisId]:
	// 												!this.state["detail" + thisId],
	// 										});
	// 									}}
	// 								>
	// 									Detail
	// 								</Tooltip>
	// 							</Link>
	// 						</span>
	// 					) : null}
	// 					{accessRole('delete') && record.promotion_status == 0 ?
	// 						<span>
	// 							<button
	// 								className="btn btn-danger btn-sm"
	// 								type="button"
	// 								id={"delete-" + thisId}
	// 								onClick={() => {
	// 									this.setState({
	// 										inactiveUuid: record.promotion_uuid,
	// 										confirm: true
	// 									})
	// 								}}
	// 								style={{
	// 									padding: '2px 5px'
	// 								}}>
	// 								<i className="uil-trash-alt"></i>
	// 							</button>
	// 							<Tooltip
	// 								style={{
	// 									marginBottom: 2
	// 								}}
	// 								placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
	// 								toggle={() => {
	// 									this.setState({
	// 										["delete" + thisId]: !this.state["delete" + thisId]
	// 									})
	// 								}}
	// 							>Hapus</Tooltip>
	// 						</span>
	// 						: null
	// 					}
	// 				</Fragment>
	// 			);
	// 		},
	// 	},
	// ];

	columns = [
        {
            key: "punishment_discipline_employee_nip",
            text: "NIP",
            className: "punishment_discipline_employee_nip",
            sortable: true,
            width: '130'
        },
        {
            key: "punishment_discipline_employee_name",
            text: "Nama",
            className: "punishment_discipline_employee_name",
            sortable: true
        },
        {
            key: "punishment_discipline_employee_work_unit",
            text: "Unit Kerja",
            className: "punishment_discipline_employee_work_unit",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_period_year",
            text: "Tahun",
            className: "punishment_discipline_period_year",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_total_day_late",
            text: "Akumulasi Hari",
            className: "punishment_discipline_total_day_late",
            sortable: true,
            width: '200',
            cell : record => {
                return record.punishment_discipline_total_day_late + ' Hari';
            }
        },
        {
            key: "punishment_discipline_punishment_name",
            text: "Rekomendasi Hukuman Disiplin",
            className: "punishment_discipline_punishment_name",
            sortable: true,
            width: '200'
        },
        // {
        //     key: "punishment_discipline_result_punishment_name",
        //     text: "Keputusan Hukuman Disiplin",
        //     className: "punishment_discipline_result_punishment_name",
        //     sortable: true,
        //     width: '200'
        // },
        {
            key: "punishment_discipline_result_final_punishment_name",
            text: "Hasil Akhir Hukuman Disiplin",
            className: "punishment_discipline_result_final_punishment_name",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_status_name",
            text: "Status",
            className: "punishment_discipline_status_name",
            sortable: true,
            width: '200'
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.punishment_discipline_id
                var  status = record.punishment_discipline_status
                return (
                    <Fragment>
                        { accessRole('read') && status == 1 &&
                            <span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: record.punishment_discipline_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-align-left"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Detail</Tooltip>
                            </span>
                        }

                        {/* {
                          status == -1 ?
                            <>
                                <span>
                                    <button
                                        className="btn btn-warning btn-sm"
                                        id={"uploadHasil-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                uploadHasilUuid: record.punishment_discipline_uuid
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-file-upload-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["uploadHasil" + thisId]} target={"uploadHasil-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["uploadHasil" + thisId] : !this.state["uploadHasil" + thisId]
                                            })
                                        }}
                                    >Input Hasil Pemeriksaan</Tooltip>
                                </span>
                            </>
                            : ""
                        } */}
						

					{
					  status == -1 && this.props.isadmin ==1 ?
						<>
							<span>
								<button
									className="btn btn-warning btn-sm"
									id={"uploadHasil-" + thisId}
									onClick={() => {
										this.setState({
											uploadHasilUuid: record.punishment_discipline_uuid
										})
									}}
									style={{
										marginRight: '2px',
										padding: '2px 5px'
									}}>
										<i className="uil-file-upload-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["uploadHasil" + thisId]} target={"uploadHasil-" + thisId}
									toggle={() => {
										this.setState({
											["uploadHasil" + thisId] : !this.state["uploadHasil" + thisId]
										})
									}}
								>Input Hasil Pemeriksaan</Tooltip>
							</span>
						</>
						: ""
					}

                        {
                          status == 0 ?
                            <>
                                <span>
                                    <button
                                        className="btn btn-warning btn-sm"
                                        id={"uploadSk-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                uploadSkUuid: record.punishment_discipline_uuid
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-file-upload-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["uploadSk" + thisId]} target={"uploadSk-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["uploadSk" + thisId] : !this.state["uploadSk" + thisId]
                                            })
                                        }}
                                    >Upload SK</Tooltip>
                                </span>
                            </>
                            : ""
                        }

                    </Fragment>
                );
            }
        }        
    ]

	render() {
		return (
			<>
				<MKIDatatable
					className={this.configDatatable.tableClass}
					config={this.configDatatable}
					records={this.state.rows}
					columns={this.columns}
					dynamic={true}
					minWidth={1000}
					total_record={this.state.totalRow}
					initial={this.state.filter}
					onChange={(filter) => {
						this.setState(
							{
								loadingTable: true,
								filter: filter,
							},
							function () {
								this.setTokenAPI();
							}
						);
					}}
					loading={this.state.loadingTable}
				/>
				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					confirmInfo={this.modal_confirm_message}

					loadingTitle="Mengirim data..."
					loadingInfo="Tunggu beberapa saat"

					successTitle="Berhasil!"
					successInfo={this.modal_confirm_sucess_message}

					failedTitle="Gagal!"
					failedInfo={this.modal_confirm_error_message}

					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}
					response={this.confirmResponse}
				/>

				<SKModal
					modal={this.state.modal}
					toggle={() => this.toggle()}
					// periodUuid={this.state.period?.cpns_period_uuid} 
					// uuid={this.state.uuid} 
					// setUuid={value => this.setUuid(value)} 
					handleReload={() => this.setTokenAPI()}
					uuid={this.state.inputSKUuid}
				/>

				<SKCollectiveModal
					modal={this.state.modalSKC}
					toggle={() => this.toggleModalSKC()}
					periodUuid={this.props.uuid}
					uuids={this.state.dataSelected}
					// uuid={this.state.uuid} 
					// setUuid={value => this.setUuid(value)} 
					handleReload={() => { this.setTokenAPI(); this.fetchListSKCollective(); }}
					uuid={this.state.inputSKUuid}
					selectedCount={this.state.dataSelected.length}
					periodDate={this.props.periodDate}
				/>

				{ this.state.uploadSkUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_sk&uuid="+ this.state.uploadSkUuid}/>
                : null }
				{ this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?detail&uuid="+ this.state.detailUuid}/>
                : null }

				{/* {console.log(this.state.VerifikasiUuid)} */}
				{ this.state.uploadHasilUuid !== null ?
					<Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_hasil&uuid="+ this.state.uploadHasilUuid}/>
				: null }
			</>
		);
	}
}

export default TablePreocessedComponent;
